// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Auth from "../../bundles/Auth/Auth.res.js";
import * as React from "react";

function AuthLogoutPage(props) {
  let auth = Auth.useState();
  let unlogUser = Auth.useUnlogUser();
  React.useEffect(() => {
    if (typeof auth === "object" && auth.TAG !== "Logging") {
      unlogUser();
    }
  }, [auth]);
  return null;
}

let make = React.memo(AuthLogoutPage);

export {
  make,
}
/* make Not a pure module */
